import { Navigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import OrdersTab from "@/pages/admin/OrdersTab";
import ProductsTab from "@/pages/admin/ProductsTab";
import SettingsTab from "@/pages/admin/SettingsTab";
import ReviewsTab from "@/pages/admin/ReviewsTab";
import SubscriptionsTab from "@/pages/admin/SubscriptionsTab";
import NewsletterTab from "@/pages/admin/NewsletterTab";
import MessagesTab from "@/pages/admin/MessagesTab";
import GiftCardsTab from "@/pages/admin/GiftCardsTab";

export default function Admin() {
  const { user, logout } = useAuth();
  if (user === null) return <div className="p-24 text-center text-slate-500">Loading…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="admin-dashboard">
      <div className="flex items-center justify-between">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#8C2220]">Shop owner</p>
          <h1 className="font-serif text-4xl font-bold">Albion Pantry admin</h1>
        </div>
        <button onClick={logout} className="flex items-center gap-2 text-sm rounded-full border px-4 py-2 hover:bg-white" data-testid="admin-logout-button"><LogOut className="w-4 h-4" /> Log out</button>
      </div>
      <Tabs defaultValue="orders" className="mt-8">
        <TabsList className="bg-[#F7F3EB] flex-wrap h-auto">
          <TabsTrigger value="orders" data-testid="admin-tab-orders">Orders</TabsTrigger>
          <TabsTrigger value="products" data-testid="admin-tab-products">Products</TabsTrigger>
          <TabsTrigger value="subscriptions" data-testid="admin-tab-subscriptions">Monthly boxes</TabsTrigger>
          <TabsTrigger value="newsletter" data-testid="admin-tab-newsletter">Newsletter</TabsTrigger>
          <TabsTrigger value="messages" data-testid="admin-tab-messages">Messages</TabsTrigger>
          <TabsTrigger value="giftcards" data-testid="admin-tab-giftcards">Gift cards</TabsTrigger>
          <TabsTrigger value="reviews" data-testid="admin-tab-reviews">Reviews</TabsTrigger>
          <TabsTrigger value="settings" data-testid="admin-tab-settings">Settings</TabsTrigger>
        </TabsList>
        <TabsContent value="orders"><OrdersTab /></TabsContent>
        <TabsContent value="products"><ProductsTab /></TabsContent>
        <TabsContent value="subscriptions"><SubscriptionsTab /></TabsContent>
        <TabsContent value="newsletter"><NewsletterTab /></TabsContent>
        <TabsContent value="messages"><MessagesTab /></TabsContent>
        <TabsContent value="giftcards"><GiftCardsTab /></TabsContent>
        <TabsContent value="reviews"><ReviewsTab /></TabsContent>
        <TabsContent value="settings"><SettingsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
